// Admin API client — /admin/service-health/* (mirrors the API's service-health aggregate).

import type { AdminServiceHealthStatus } from '@a7y/types';
import { client } from './transport';

export const serviceHealthApi = {
  // Service Health
  getServiceHealth: () => client.get<{ data: AdminServiceHealthStatus[] }>('/service-health'),
  refreshServiceHealth: () =>
    client.post<{ data: AdminServiceHealthStatus[] }>('/service-health/refresh', {}),
};
